import {createRouter, createWebHistory} from "vue-router";

import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ServiceView from "../views/ServiceView.vue";
import CareerView from "@/views/CareerView.vue";
import ProductView from "@/views/ProductView.vue";
import ImpressumView from "@/views/ImpressumView.vue";
import DatenschutzView from "@/views/DataSecurityView.vue";
import ContactView from "@/views/ContactView.vue";

const routes = [
    {
        path: "/",
        name: "home",
        component: HomeView,
        meta: {
            title: "KFZ Musterwerkstatt - Kfz-Werkstatt in Musterstadt",
            description: "KFZ Musterwerkstatt in Musterstadt: Ihre Kfz-Werkstatt für Inspektion, Wartung, Reparatur, Diagnose, Reifenservice und Klimaservice."
        }
    },
    {
        path: "/about",
        name: "about",
        component: AboutView,
        meta: {
            title: "Über uns - KFZ Musterwerkstatt Musterstadt",
            description: "Lernen Sie KFZ Musterwerkstatt in Musterstadt kennen: persönliche Beratung, zuverlässige Werkstattarbeit und moderner Kfz-Service."
        }
    },
    {
        path: "/services",
        name: "services",
        component: ServiceView,
        meta: {
            title: "Leistungen - Kfz-Service und Autoreparatur in Musterstadt",
            description: "Kfz-Leistungen in Musterstadt: Inspektion, Wartung, Bremsenservice, Diagnose, Motor- und Getriebereparatur, Reifenservice, Klimaservice und mehr."
        }
    },
    {
        path: "/career",
        name: "career",
        component: CareerView,
        meta: {
            title: "Karriere - KFZ Musterwerkstatt",
            description: "Karriere bei KFZ Musterwerkstatt in Musterstadt: Bewerben Sie sich als Kfz-Mechatroniker und werden Sie Teil unseres Werkstattteams."
        }
    },
    {
        path: "/products",
        name: "products",
        component: ProductView,
        meta: {
            title: "Produkte - Autopflege, Öle und Zubehör in Musterstadt",
            description: "Produkte bei KFZ Musterwerkstatt: hochwertige Öle, Batterien, Pflegeprodukte und Zubehör passend zu Ihrem Fahrzeug."
        }
    },
    {
        path: "/impressum",
        name: "impressum",
        component: ImpressumView,
        meta: {
            title: "Impressum - KFZ Musterwerkstatt",
            description: "Impressum der KFZ Musterwerkstatt in Musterstadt mit Anbieterkennzeichnung, Kontakt und rechtlichen Angaben."
        }
    },
    {
        path: "/datenschutz",
        name: "datenschutz",
        component: DatenschutzView,
        meta: {
            title: "Datenschutz - KFZ Musterwerkstatt",
            description: "Datenschutzerklärung der KFZ Musterwerkstatt in Musterstadt mit Informationen zur Verarbeitung personenbezogener Daten."
        }
    },
    {
        path: "/contact",
        name: "contact",
        component: ContactView,
        meta: {
            title: "Kontakt - KFZ Musterwerkstatt Musterstadt",
            description: "Kontaktieren Sie KFZ Musterwerkstatt in Musterstadt telefonisch, per E-Mail oder über das Kontaktformular."
        }
    },
];

const scrollBehavior = (
    _to: unknown,
    _from: unknown,
    _savedPosition: { left: number; top: number } | null
) => {
    return _savedPosition ?? {top: 0}
}

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior
})

export default router;
